import { render } from "./SearchView.vue?vue&type=template&id=4487ec3c&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=4487ec3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4487ec3c"]])

export default __exports__